import { render, staticRenderFns } from "./MySignal.vue?vue&type=template&id=4b42b874&scoped=true"
import script from "./MySignal.vue?vue&type=script&lang=js"
export * from "./MySignal.vue?vue&type=script&lang=js"
import style0 from "./MySignal.vue?vue&type=style&index=0&id=4b42b874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b42b874",
  null
  
)

export default component.exports